import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { convertDataSelectBox, layDanhMucChucVu } from '../../services/danhmuc';

const ChucVuSelectBox = ({ value, disabled, onChange, allowClear }: { value?: number, disabled?: boolean, onChange: (e: any) => void, allowClear?: boolean}) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = convertDataSelectBox(await layDanhMucChucVu());
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%', height: '35px'}}
            showSearch
            placeholder="--Chọn chức vụ--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            value={value}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            disabled={disabled}
            allowClear={allowClear}
        />
    );
};

export default ChucVuSelectBox;
